import React from 'react';

import styles from './ColumnTitleSeparator.module.scss';

const ColumnTitleSeparator: React.FC = () => (
	<span className={styles.separator}>&#9679;</span>
);

export default ColumnTitleSeparator;
